import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

type ArchiveAiSuggestionsInRangeVariables = {
	startDate: Date;
	endDate: Date;
	impersonationContext?: Api.IImpersonationContext;
};

export const useArchiveAiSuggestionsInRangeMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (archivedCount: number, variables: ArchiveAiSuggestionsInRangeVariables) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ startDate, endDate, impersonationContext }: ArchiveAiSuggestionsInRangeVariables) => {
			return userSession.webServiceHelper.callAsync<number>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'ContentCalendarSuggestion/ai/archive',
					impersonationContext,
				}),
				'POST',
				{
					startDate: startDate.toISOString(),
					endDate: endDate.toISOString(),
				}
			);
		},
		onError,
		onSuccess,
	});
};
